import OnboardingHiImGreg from './components/OnboardingHiImGreg.js';
import connect from './connect';
import './assets/OnboardingHiImGreg.css';

export default connect(OnboardingHiImGreg);



// WEBPACK FOOTER //
// ./src/routes/OnboardingHiImGreg/index.js